import React from 'react'

import Tooltip from 'components/tooltips/Tooltip'
import Icon from 'components/elements/Icon'

import { LegalityBlock, LegalityLabel } from '../style'

const LegalityKey = () => (
  <Tooltip trigger={<Icon style={{ color: '#cdcdcd' }} name="question" />} style={{ maxWidth: 'unset' }}>
    <LegalityBlock>
      <LegalityLabel small legality="legal">
        {' '}
        Legal{' '}
      </LegalityLabel>
      <LegalityLabel small legality="restricted">
        {' '}
        Restricted{' '}
      </LegalityLabel>
      <LegalityLabel small legality="banned">
        {' '}
        Banned{' '}
      </LegalityLabel>
      <LegalityLabel small legality="not_legal">
        {' '}
        Not Legal{' '}
      </LegalityLabel>
    </LegalityBlock>
  </Tooltip>
)

export default LegalityKey
